import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { PRODUCT } from '../data/product';

export default function HomePage() {
  return (
    <div className="home-page">
      <section className="home-hero home-hero-showcase">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45 }}
          className="home-hero-panel"
        >
          <div className="home-hero-copy">
            <p className="home-kicker">Bluetooth Speakers</p>
            <h1 className="home-hero-title">Spark your life.</h1>
            <p className="home-hero-subtitle">
              Our <strong>Range</strong> Of <strong>Speakers</strong>
            </p>

            <div className="home-cta-row">
              <Link to="/product" className="home-explore-btn">
                Explore Now
              </Link>
            </div>
          </div>

          <div className="home-hero-art">
            <img src="/home-hero-image.webp" alt="Home hero speaker showcase" className="hero-device" />
          </div>
        </motion.div>
      </section>

      <section className="home-section">
        <h2>Choose Your Color</h2>
        <div className="color-list">
          {PRODUCT.colors.map((item) => (
            <article key={item.name} className="color-preview-card">
              <img src={item.image} alt={item.name} />
              <h3>{item.name}</h3>
            </article>
          ))}
        </div>
      </section>

      <section className="home-section">
        <h2>Why Ditoo-Pro?</h2>
        <div className="feature-list">
          {PRODUCT.descriptionPoints.slice(0, 3).map((point) => (
            <article key={point} className="feature-card">
              <p>{point}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="home-banner-image">
        <img src={PRODUCT.belowHeroImage} alt="Ditoo-Pro lifestyle" />
      </section>

      <section className="home-banner-image">
        <img src="/home-page-image.png" alt="Ditoo-Pro home page showcase" />
      </section>

      <section className="home-banner-image">
        <img src="/home-footer-image.png" alt="Ditoo-Pro home footer showcase" />
      </section>
    </div>
  );
}
